<template>
  <full-page title="Smart Lodging">
    <SmartLodging />
  </full-page>
</template>

<script>
import SmartLodging from "@/components/point-of-sale/sales/SmartLodging.vue";
import FullPage from "@/components/layout/utils/FullPage";

export default {
  name: "SmartLodgingView",
  components: { FullPage, SmartLodging }
};
</script>
